<template>
    <div
        ref="progressBar"
        class="progress-bar"
        :style="{ height: strokeWidth + 'px' }"
        @click="handleChange"
    >
        <div
            class="progress-outer"
            :style="{ height: strokeWidth + 'px', borderRadius: strokeWidth + 'px' }"
            @mouseenter="handleMouseEnter"
            @mousemove="handleMouseMove"
            @mouseleave="handleMouseLeave"
        >
            <div
                class="progress-inner"
                :style="{
                    height: strokeWidth + 'px',
                    borderRadius: strokeWidth + 'px',
                    width: percentage + '%'
                }"
            ></div>
        </div>
        <div
            v-show="showTip"
            ref="progressPlaceholder"
            class="progress-placeholder"
            :style="placeholderStyle"
        >
            {{ formatTooltip(currentPosition) }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProgressBar',
    props: {
        percentage: {
            type: Number,
            validator: (val) => val >= 0 && val <= 100
        },
        strokeWidth: {
            type: Number,
            default: 10
        },
        formatTooltip: {
            type: Function,
            default: (val) => val.toString()
        }
    },
    data() {
        return {
            placeholderStyle: {
                left: 0,
                top: '-40px'
            },
            showTip: false,
            currentPosition: 0
        };
    },
    methods: {
        /**
         * 获取进度条相对距离
         */
        getRelativeDistance(e) {
            const progressRect = this.$refs['progressBar'].getBoundingClientRect();
            const distance = e.pageX - progressRect.left;
            return distance;
        },
        /**
         * 获取进度
         */
        getProgress(e) {
            const progressRect = this.$refs['progressBar'].getBoundingClientRect();
            const distance = this.getRelativeDistance(e);
            return distance / progressRect.width;
        },
        handleChange(e) {
            const value = this.getProgress(e);
            this.$emit('change', value);
        },
        handleMouseEnter(e) {
            const distance = this.getRelativeDistance(e);
            this.placeholderStyle.left = distance + 'px';
            this.currentPosition = this.getProgress(e);
            this.showTip = true;
        },
        handleMouseMove(e) {
            const distance = this.getRelativeDistance(e);
            this.placeholderStyle.left = distance + 'px';
            this.currentPosition = this.getProgress(e);
        },
        handleMouseLeave(e) {
            const distance = this.getRelativeDistance(e);
            this.placeholderStyle.left = distance + 'px';
            this.currentPosition = this.getProgress(e);
            this.showTip = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.progress {
    &-bar {
        width: 100%;
        position: relative;
    }
    &-outer {
        width: 100%;
        background-color: #1e1e1e;
        overflow: hidden;
        cursor: pointer;
        position: relative;
    }
    &-inner {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        overflow: hidden;
        background-color: #404040;
        cursor: pointer;
        z-index: 99;
    }
    &-placeholder {
        position: absolute;
        background: #303133;
        color: #fff;
        border-radius: 4px;
        padding: 10px;
        z-index: 2000;
        font-size: 12px;
        line-height: 1.2;
        min-width: 10px;
        z-index: 99;
    }
}
</style>
